import React, { useEffect } from "react";
import { useFormik } from "formik";
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Select,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import * as Yup from 'yup';
import FullScreenSection from "./FullScreenSection";
import useSubmit from "../hooks/useSubmit";
import { useAlertContext } from "../context/alertContext";

const LandingSection = () => {
  const { isLoading, response, submit } = useSubmit();
  const { onOpen } = useAlertContext();

  const formik = useFormik({
    initialValues: {
      name: "",
      mail: "",
      subject: "hireMe",
      message: "",
    },
    onSubmit: (values) => { submit("https://littlelemonrestaurant-mdogan89s-projects.vercel.app/contact/", values) },

    validationSchema: Yup.object().shape({
      name: Yup.string().required('Required'),
      message: Yup.string()
        .min(10, 'Must be at least 10 characters')
        .required('Required'),
      mail: Yup.string().email('Invalid email address')
        .required('Required')
    })
  })
  useEffect(() => {
    if (response) {
      onOpen(response.type, response.message);
      if (response.type === "success") {
        formik.resetForm();
      }
    }
  }, [response])

  return (
    <FullScreenSection
      isDarkBackground
      backgroundColor="#101D32"
      py={{ base: 16, md: 24 }}
      px={{ base: 5, md: 8 }}
      spacing={8}
    >
      <VStack w="100%" maxWidth="760px" p={{ base: 0, md: 4 }} alignItems="flex-start">
        <Heading as="h2" id="contactme-section">
          Contact me
        </Heading>
        <Box p={{ base: 5, md: 8 }} rounded="xl" w="100%" minWidth="200px" bg="whiteAlpha.100" border="1px solid" borderColor="whiteAlpha.200">
          <form onSubmit={formik.handleSubmit}>
            <VStack spacing={4}>
              <FormControl isInvalid={formik.errors.name && formik.touched.name}>
                <FormLabel htmlFor="name">Name</FormLabel>
                  <Input bg="whiteAlpha.100" borderColor="whiteAlpha.300"
                  id="name"
                  name="name"
                  {...formik.getFieldProps("name")}
                />
                <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={formik.errors.mail && formik.touched.mail}>
                <FormLabel htmlFor="mail">Email Address</FormLabel>
                  <Input bg="whiteAlpha.100" borderColor="whiteAlpha.300"
                  id="mail"
                  name="mail"
                  type="email"
                  {...formik.getFieldProps("mail")}
                />
                <FormErrorMessage>{formik.errors.mail}</FormErrorMessage>
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="subject">Type of enquiry</FormLabel>
                <Select id="subject" name="subject" bg="whiteAlpha.100" borderColor="whiteAlpha.300" {...formik.getFieldProps("subject")}>
                  <option value="spaceio">Space.io publishing/acqusition</option>
                  <option value="mobile">
                    Mobile development opportunity
                  </option>
                  <option value="contract">
                    Contract or collaboration
                  </option>
                  <option value="other">Other</option>
                </Select>
              </FormControl>
              <FormControl isInvalid={formik.errors.message && formik.touched.message}>
                <FormLabel htmlFor="message">Your message</FormLabel>
                <Textarea bg="whiteAlpha.100" borderColor="whiteAlpha.300"
                  id="message"
                  name="message"
                  height={250}
                  {...formik.getFieldProps("message")}
                />
                <FormErrorMessage>{formik.errors.message}</FormErrorMessage>
              </FormControl>
              <Button type="submit" bg="teal.200" color="#06141C" _hover={{ bg: "teal.100" }} width="full" isLoading={isLoading}>
                Submit
              </Button>
            </VStack>
          </form>
        </Box>
      </VStack>
    </FullScreenSection>
  );
};

export default LandingSection;
